const getPackageSize = (variantId, isCartItem) => {
  const packageSize = document.querySelector(`#${isCartItem ? 'cart-' : ''}variant-${variantId}`)?.value;
  return parseInt(packageSize);
}

const clickQuantityLink = (link) => {
  if (link) {
    if (link.classList.contains('line-item__remove-button')) {
      return link.href;
    }
    let lineItem = link.closest('.line-item__content-wrapper');
    if (!lineItem) {
      lineItem = link.closest('.line-item');
    }
    const variantId = lineItem.querySelector('.product-item-meta__title').getAttribute('href').split('?variant=')[1];
    const hrefItems = link.href.split('?quantity=')[1].split('&');
    const defaultTagetQuantity = parseInt(hrefItems[0]);
    const currentQuantity = parseInt(lineItem.querySelector('.quantity-selector__input').value);
    const quantity = getPackageSize(variantId);
    let targetQuantity;
    if(!isNaN(quantity)) {
       targetQuantity = currentQuantity < defaultTagetQuantity ? currentQuantity + quantity : currentQuantity < quantity ? 0 : currentQuantity - quantity;
    } else {
      targetQuantity = defaultTagetQuantity;
    }
    return `/cart/change?quantity=${targetQuantity}&${hrefItems[1]}`;
  }
  return link.href;
}
const checkQuantityValidation = (input) => {
  if (input) {
    const targetQuantity = parseInt(input.value);
    let lineItem = input.closest('.line-item__content-wrapper');
    if (!lineItem) {
      lineItem = input.closest('.line-item');
    }
    const errorMessages = lineItem.querySelectorAll('.line-item__quantity .error');
    const variantId = lineItem.querySelector('.product-item-meta__title').href.split('?variant=')[1];
    const quantity = getPackageSize(variantId);
    if (!isNaN(quantity) && quantity > 0 && targetQuantity % quantity !== 0) {
      errorMessages.forEach(errorMessage => {
        errorMessage.classList.add('show');
      });
      return false;
    }
    errorMessages.forEach(errorMessage => {
      errorMessage.classList.remove('show');
    });
    return true;
  } else {
    return true;
  }
}

document.addEventListener('keypress',(e)=>{
  if(e.target.classList.contains('quantity-selector__input') && e.target.closest('.mini-cart')) {
    if(e.key === 'Enter') {
      e.preventDefault();
      e.target.dispatchEvent(new Event('change',{
        'bubbles': true,
        'cancelable': false
      }));
    }
  }
});